<template>
  <sign-page
    title-text="岗位总览"
    :request="request"
    table-size="large"
    :search-parms="searchParms"
    :initSearchData="{year: $datetime.format(new Date(), 'Y')}"
    @clickTitleMenu="clickTitleMenu"
    :titleMenus="[{key: 'batch', label: '批量调岗'}]"
    :column-list="columnList"
    :tableActions="[]"
    :dealSearchParm="dealSearchParm"
    :table-actions-fixed="true"
    :tableActionsWidth="100"
    :need-data-file="true">
    <wage-form
      @dataUpdate="dataUpdate"
      :columnList="columnList"
      :formatValue="formatValue"
      valueKey="wageJobTitleTitle"
      type="wageJobTitle"
      :workerList="workers"
      :wageJobTitleList="wageJobTitles"
      ref="wafeForm"
      title="批量调岗"></wage-form>
  </sign-page>
</template>

<script>
import {
  workerWageRequest as request,
  wageJobTitleRequest,
  performanceWorkerRequest
} from '../../api'
import WageForm from './cmp/form'
import { number } from 'echarts'

export default {
  components: {
    WageForm
  },
  created () {
    this.loadWorker()
    this.loadJobTitle()
  },
  methods: {
    async loadJobTitle () {
      let datas = await wageJobTitleRequest.get({})
      this.wageJobTitles = datas.map(v => {
        return {
          key: v.id,
          label: v.jobTitleType + ' ' + (v.mLevel ? v.mLevel + ' ' : '') + v.title,
          data: v
        }
      })
    },
    formatValue (data) {
      return data.wageJobTitleId ? (data.wageJobTitleType || '') + (data.wageJobTitleTitle ? data.wageJobTitleTitle : '') : '无'
    },
    async loadData (parm) {
      let data = await request.get(parm)
      let dataMap = {}
      data.forEach(v => {
        if (!dataMap[v.performanceWorkerId]) {
          dataMap[v.performanceWorkerId] = {
            workerName: v.workerName
          }
        }
        dataMap[v.performanceWorkerId]['value_' + Number(v.month.slice(5))] = (v.wageJobTitleType || '') + (v.wageJobTitleTitle ? v.wageJobTitleTitle : '')
      })
      return Object.keys(dataMap).map(key => dataMap[key])
    },
    dataUpdate () {
      this.pageVm.loadData()
    },
    dealSearchParm (parm) {
      if (parm) {
        parm.year = parm.year && parm.year instanceof Date ? this.$datetime.format(parm.year, 'Y') : parm.year
      }
      return parm
    },
    clickTitleMenu (key, pageVm) {
      this.pageVm = pageVm
      if (key === 'batch') {
        this.$refs.wafeForm.open()
      }
    },
    async loadWorker () {
      let datas = await performanceWorkerRequest.get({})
      this.workers = datas.map(v => {
        return {
          key: v.id,
          label: v.name,
          data: v
        }
      })
    }
  },
  computed: {
    searchParms () {
      return [{
        type: 'yearPicker',
        placeholder: '年份',
        key: 'year',
        default: new Date()
      },
      {
        type: 'input',
        placeholder: '姓名',
        key: 'likeWorkerName'
      }]
    },
    columnList: {
      get () {
        let data = [{
          title: '',
          fixed: 'left',
          field: 'workerName'
        }]
        let i = 1
        while (i < 13) {
          data.push({
            title: i + '月',
            field: 'value_' + i,
            sort: true,
            type: number
          })
          i += 1
        }
        return data
      }
    }
  },
  data () {
    return {
      workers: [],
      wageLeves: [],
      wageJobTitles: [],
      request: {
        get: this.loadData
      }
    }
  }
}
</script>
